import React from "react"
import styled from "styled-components"
import FeatureCard from "../FeatureCard/featureCard"

const Section = styled.section`
  padding: 50px 0 100px;
`

const HeadlineGroup = styled.div`
  margin: 0 auto;
  max-width: 800px;
  text-align: center;
`

const Headline = styled.h4`
  font-size: 30px;
  font-weight: 700;
  color: #252323;
  text-transform: uppercase;
`

const SubHeadline = styled.h3`
  font-size: 40px;
  font-weight: 700;
  color: #005e7a;
`

const CardGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-gap: 50px;
  justify-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 50px;

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, auto);
  }
`

const Features = () => (
  <Section>
    <HeadlineGroup>
      <Headline>Features</Headline>
      <SubHeadline>Fast and easy appointment management</SubHeadline>
    </HeadlineGroup>
    <CardGroup>
      {featuresList.map(({ title, text }) => (
        <FeatureCard title={title} text={text} key={title} />
      ))}
    </CardGroup>
  </Section>
)

let featuresList = [
  {
    title: "Calendar",
    text:
      "Review and manage your appointments in a calendar timeline. Add events for specific client and service. Set custom cost and service duration.",
  },
  {
    title: "Clients",
    text:
      "Create and manage your client database. Add notes for specific client and review history of provided services.",
  },
  {
    title: "Services",
    text:
      "Create and manage your services with specified duration, cost, and color.",
  },
  {
    title: "Currencies",
    text:
      "Update currency used throughout in app. Currently available: EUR, USD, GBP, RUB.",
  },
]

export default Features
